// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Crimson+Text:wght@400;600;700&family=Martel:wght@400;600;700&display=swap);"]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Kaushan+Script);"]);
// Module
exports.push([module.id, ".main-wrapper {\n  margin: 0 auto;\n  font-family: 'Crimson Text', 'Martel', serif; }\n", ""]);
// Exports
module.exports = exports;
